import { Routes } from '@angular/router';
import { AppShell } from './layout/app-shell';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: AppShell,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./features/dashboard/dashboard').then((m) => m.Dashboard),
        title: 'menu.dashboard',
      },
      {
        path: 'tenants',
        loadChildren: () => import('./features/tenants/tenants.routes'),
        title: 'menu.tenants',
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes'),
        title: 'menu.users',
      },
      {
        path: 'accountants',
        loadChildren: () => import('./features/accountants/accountants.routes'),
        title: 'menu.accountants',
      },
      {
        path: 'hr-staff',
        loadChildren: () => import('./features/hr-staff/hr-staff.routes'),
        title: 'menu.hrStaff',
      },
      {
        path: 'plans',
        loadChildren: () => import('./features/plans/plans.routes'),
        title: 'menu.plans',
      },
      {
        path: 'payments',
        loadChildren: () => import('./features/payments/payments.routes'),
        title: 'menu.payments',
      },
      {
        path: 'promo-codes',
        loadChildren: () => import('./features/promo-codes/promo-codes.routes'),
        title: 'menu.promoCodes',
      },
      {
        path: 'default-template',
        loadChildren: () => import('./features/default-template/default-template.routes'),
        title: 'menu.defaultTemplate',
      },
      {
        path: 'statistics',
        loadChildren: () => import('./features/statistics/statistics.routes'),
        title: 'menu.statistics',
      },
      {
        path: 'support',
        loadComponent: () => import('./features/support/support').then((m) => m.Support),
        title: 'menu.support',
      },
      {
        path: 'settings',
        loadChildren: () => import('./features/settings/settings.routes'),
        title: 'menu.settings',
      },
    ],
  },
  { path: 'auth', loadChildren: () => import('./features/auth/auth.routes') },
  { path: '**', redirectTo: '' },
];
